import BaseComponent from '../core/base-component.js';

interface FullscreenConfig {
    target: string;
    background: string;
}



const DEFAULT_ELEMENT_SELECTOR: string = '[data-toggle="fullscreen"],[data-bs-toggle="fullscreen"]';

const defaultOptions: FullscreenConfig = {
    target: '',
    background: '#fff'
};

class Fullscreen extends BaseComponent {
    protected options: FullscreenConfig;

    public override init() {
        this.options = this.assignConfig<FullscreenConfig>(defaultOptions, this.config);
    }

    public override process() {
        const self = this;
        const targetEl = document.querySelector<HTMLElement>(this.options.target);
        if(targetEl) {
            const initialBackground = targetEl.style.background;
            targetEl.addEventListener('fullscreenchange', () => {
                if(document.fullscreenElement) {
                    self.element.classList.add('fullscreen');
                    self.element.setAttribute('aria-expanded', 'true');
                    targetEl.classList.add('fullscreenmode');
                    if(self.options.background != '') {
                        targetEl.style.background = self.options.background;
                    }
                } else {
                    self.element.classList.remove('fullscreen');
                    self.element.setAttribute('aria-expanded', 'false');
                    targetEl.classList.remove('fullscreenmode');
                    targetEl.style.background = initialBackground;
                }
            });
            this.element.addEventListener('click', (ev: MouseEvent) => {
                if(document.fullscreenElement) {
                    document.exitFullscreen();
                } else {
                    targetEl.requestFullscreen();
                }
            });
        }


    }
}

// Observe
Fullscreen.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type  { FullscreenConfig };
export default Fullscreen;
